import { waitForTailwind } from '@utils/waitForTailwind'
import { i18n, LANG_COOKIE_NAME, urlLang } from '@i18n/i18n'
import { getCookie, setCookie } from '@utils/cookies'
import { Lang } from '@src/models/signals'

if (urlLang) {
	setCookie(LANG_COOKIE_NAME, urlLang, { maxAge: 315360000 }) // 10 years
}

// A tab woken after a deploy can boot the previous build (the service worker's offline shell, a
// restored tab), whose chunks are gone and whose version checker sits in one of them. The live
// index.html no longer naming this entry proves the build moved, so reload. Once the app is up,
// the version checker's prompt handles it instead.
window.addEventListener('vite:preloadError', async () => {
	if (document.querySelector('version-checker')) return
	try {
		const response = await fetch('/', { cache: 'no-cache' })
		const entry = new URL(import.meta.url).pathname.split('/').pop()!
		if (response.ok && !(await response.text()).includes(entry)) window.location.reload()
	} catch {
		// Offline: nothing proves the build moved yet
	}
})

const initialLang = (getCookie(LANG_COOKIE_NAME) as Lang) || 'en'

i18n.load(initialLang, () => {
	import('@components/shared/bulk-menu')
	import('@components/shared/bb-toast-stack')
	import('vanilla-calendar-pro/styles/index.css')
	import('./index.css')

	import('@src/app/')
	import('@src/app/side-bar')
	import('@components/getting-started/getting-started-back')

	import('@components/person/connected-person')
})

//Start app
const body = document.querySelector('body')!
body.appendChild(document.createElement('app-body'))
waitForTailwind()

const sentryHost = window.location.hostname
if (/\.beebole\.com$/.test(sentryHost) && !sentryHost.startsWith('qa.')) {
	import('@utils/sentry').then((m) => m.initSentry())
}

// Deferred third-party inits — runs independently of app startup
setTimeout(() => {
	import('@src/services/pushNotification').then((m) => m.pushNotificationService.init())
	import('@components/person/intercom-messenger').then(() => {
		const el = document.querySelector('connected-person')
		if (el) el.appendChild(document.createElement('intercom-messenger'))
	})
}, 2000)
